import ready from "../supports/ready";

export default async function() {
    await ready();
    document.documentElement.classList.remove('no-js');
}